import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NotificationService } from 'src/app/services/notifications/notification.service';
import { UtilService } from 'src/app/services/common/utils.service';
import { UserService } from "src/app/services/user/user.service";
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { PageTermsConditionsPage } from '../page-terms-conditions/page-terms-conditions.page';
import { PrivacyPoliciesPage } from '../privacy-policies/privacy-policies.page';

@Component({
  selector: 'app-notifications-channels',
  templateUrl: './notifications-channels.page.html',
  styleUrls: ['./notifications-channels.page.scss'],
})
export class NotificationsChannelsPage implements OnInit {
  channelSms: boolean = true;
  channelEmail: boolean = true;
  channelPush: boolean = true;
  terms: boolean = false;
  disabledBtnAccept: boolean = true;
  politic: boolean = false;
  constructor(
    private modalController: ModalController,
    private notiServices: NotificationService,
    private util: UtilService,
    private userService: UserService,
    public languageService: LanguagesService,
  ) {

  }

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  async acceptNoti() {
    try {
      await this.util.showLoading('Enviando...');
      const data: any = {
        sms: this.channelSms,
        email: this.channelEmail,
        push: this.channelPush,
      };
      (await this.notiServices.acceptChannels(data)).subscribe(
        async () => {
          await this.util.closeLoading(null);
          await this.userService.acceptTermsConditions();
          this.userService.updateField("notificationTerms", true);
          this.userService.updateField("notificationTermsFail", false);
          this.dismiss();
        },
        async (err: any) => {
          console.log("notifications Channel",err);
          await this.util.closeLoading(null);
          //await this.util.showAlert('Ocurrio un error por favor intenta nuevamente.');
          this.userService.updateField("notificationTerms", true);
          this.userService.updateField("notificationTermsFail", true);
          this.dismiss();
        }
      );
    } catch (error) {
      console.log("error notifications",error);
    }
  }

  // validateTermsAndNotifications() {
  //   if (this.terms && (this.channelSms || this.channelEmail || this.channelPush)) {
  //     this.disabledBtnAccept = false;
  //   } else {
  //     this.disabledBtnAccept = true;
  //   }
  // }

  // channelCheck(event: any, channel: string) {
  //   switch (channel) {
  //     case 'sms':
  //       this.channelSms = event.target.checked;
  //       break;
  //     case 'email':
  //       this.channelEmail = event.target.checked;
  //       break;
  //     case 'push':
  //       this.channelPush = event.target.checked;
  //       break;
  //     default:
  //       console.log("No se selecciono canal");
  //       break;
  //   }
  //   this.validateTermsAndNotifications();
  // }

  verifyTerms(event: any) {
    this.terms = event.target.checked;
    if (this.terms && this.politic) {
      this.disabledBtnAccept = false;
    } else {
      this.disabledBtnAccept = true;
    }
    // this.validateTermsAndNotifications()
    // console.log(this.terms);
  }
  verifyPolitical(event: any) {
    this.politic = event.target.checked;
    if (this.terms && this.politic) {
      this.disabledBtnAccept = false;
    } else {
      this.disabledBtnAccept = true;
    }
    // this.validateTermsAndNotifications()
    // console.log(this.terms);
  }

  async verTerms(){
    // this.routerService.navigate("/page-terms-conditions")
    const modal = await this.modalController.create({
      component: PageTermsConditionsPage,
      id: "modal-terms-conditions",
      cssClass: "gnx-modal gnx-modal-absolute",
      componentProps: {
        "isModal": true
      }
    });
    return await modal.present();
  }

  async verPolices(){
    // this.routerService.navigate("/page-terms-conditions")
    const modal = await this.modalController.create({
      component: PrivacyPoliciesPage,
      id: "modal-privacy-policies",
      cssClass: "gnx-modal gnx-modal-absolute",
      componentProps: {
        "isModal": true
      }
    });
    return await modal.present();
  }

  get getTextsIUNotificationsChannel() {

    return this.languageService.textsIU.modals.notifications_channel;
  }
}